export default __webpack_public_path__ + "static/media/edit-gift-bg.7e6d276f.webp";